import { DocsEntityType } from "../../enums/SDKDocsEntityType";
import { DocsEntity } from "./SDKDocsEntity";
import { DocsEntityApprovalState } from "./SDKDocsEntityApprovalState";
import { DocsEntityConfiguration } from "./SDKDocsEntityConfiguration";
import { DocsEntityDraftState } from "./SDKDocsEntityDraftState";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsEntityGroup extends DocsEntity {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        super(model);
        this.isRoot = model.isRoot;
        this.childrenIds = model.childrenIds;
        this.groupBehavior = model.groupBehavior;
        this.relativeFirstPageUrl = null;
        this.deployedFirstPageUrl = null;
        this.parentId = null;
        this.children = [];
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Convenience
    /** Internal: Modifies object with new paths. Don't use outside SDK environment as it doesn't propagate the data back to source */
    internalOverridePaths(relative, deployed) {
        this.relativeFirstPageUrl = relative;
        this.deployedFirstPageUrl = deployed;
    }
    /** Retrieve relative page path without the associated domain for the first page in the group. Will work even when documentation was not yet deployed */
    relativeDocsPageUrl() {
        return this.relativeFirstPageUrl;
    }
    /** Retrieve page url for the first page in the group, if the documentation was already deployed (either default or custom domain) */
    deployedDocsPageUrl() {
        return this.deployedFirstPageUrl;
    }
}
/** Lightweight page representation used in multiplayer context type-validated against the full version */
export class DocsEntityMultiplayerGroup {
    constructor(model) {
        var _a, _b, _c;
        this.persistentId = model.persistentId;
        this.type = DocsEntityType.group;
        this.title = model.title;
        this.groupBehavior = model.groupBehavior;
        this.childrenIds = model.childrenIds;
        this.isRoot = model.isRoot;
        // Will be set on the fly
        this.parent = null;
        this.parentId = null;
        this.draftState = model.draftState
            ? new DocsEntityDraftState(model.draftState)
            : null;
        this.approvalState = new DocsEntityApprovalState(model.approvalState || null, this.draftState);
        // this is used also for documentation hierarchy endpoint :( it has to be reworked
        this.configuration = new DocsEntityConfiguration(model.configuration, model.title);
        this.isPrivate = Boolean((_a = model.configuration) === null || _a === void 0 ? void 0 : _a.isPrivate);
        this.isHidden = Boolean((_b = model.configuration) === null || _b === void 0 ? void 0 : _b.isHidden);
        this.publishMetadata = (_c = model.publishMetadata) !== null && _c !== void 0 ? _c : null;
    }
}
